<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative">
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor"
        style="height: 62px; z-index:1000;">
        <!-- SM - OPEN SIDEBAR BUTTON -->

        <menu-icon size="1.5x" class="custom-class xl:hidden mr-2 cursor-pointer"
          style="position: absolute; left: 10px; top: 30%; margin-right: 20px" @click.stop="showSidebar"></menu-icon>

        <!--  hidden sm:block -->

        <!-- event header -->
        <template v-if="header.title != null">
          <div class="cursor-pointer hidden sm:block hover-hightlight" style="" @click="doAction(header.action)">
            <img v-if="header.image != null" :src="header.image" class="header-logo" />
            <div class="header-text">
              <strong style>{{ header.title }} </strong>
              <div>
                <span style="font-size: 0.8rem; color: #aaa; margin-left: 0px">{{ header.excerpt }}</span>
              </div>
              <i class="icon far fa-arrow-alt-circle-down"></i>
            </div>
          </div>
        </template>

        <!--
        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />
        <vs-spacer />
        -->
        <!--
        <notification-drop-down />
        -->
        <!--
        <search-bar />
        -->
        <div class="help-icon" >
          <div class="d-flex">
            <vs-button v-if="role == 'so-admin' || role == 'admin'" type="border" size="small" class="mr-3" to="/events/addquick">
              <div class="help-icon-text">

                Add Event
              </div>
            </vs-button>
            <vs-button type="border" size="small" @click="openHelp()">
              <div class="help-icon-text">
                <i class="fa fa-question-circle" aria-hidden="true"></i>

                Help
              </div>
            </vs-button>
          </div>
        </div>
        <profile-drop-down />
      </vs-navbar>
      <event-dialog :showDialog="eventDialog" :merchant="s" @close="eventDialog = false"
        @submit="onEventSubmit"></event-dialog>
    </div>
  </div>
</template>

<script>
import Bookmarks from "./components/Bookmarks.vue";
import SearchBar from "./components/SearchBar.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";

import { MenuIcon } from "vue-feather-icons";

import EventListPopup from "@/components/soldoutt/EventListPopup.vue";
import EventDialog from "@/components/soldoutt/EventDialog.vue";

import Service from "@/services";
import { mapState } from "vuex";

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff"
    }
  },
  components: {
    MenuIcon,
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    EventListPopup,
    EventDialog
  },
  data: () => ({
    eventDialog: false,
    eventList: [],
    role: 'user'
  }),
  computed: {
    ...mapState({
      header: state => {
        return state.Utility.header;
      },
      /*
      permission: state => {
        return state.Auth.permission;
      },
      */
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    }),
    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff"
        ? "#10163a"
        : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return {
        "text-white":
          (this.navbarColor != "#10163a" &&
            this.$store.state.theme === "dark") ||
          (this.navbarColor != "#fff" && this.$store.state.theme !== "dark")
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default") return "navbar-default";
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
    }
  },
  created() {
    if (this.header.title == "" || this.header.title == null) {
      this.setDefaultHeader();
    } else {
      Service.Event.get(this.$route.query.e)
        .then(res => {
          if (res.data.event == null) {
            console.log("no event found");
            return;
          }

          let header = {
            slug: res.data.event.e,
            title: res.data.event.pro_name,
            excerpt: res.data.event.date,
            image: res.data.event.merchant.logo,
            action: "openEventList"
          };
          this.$store
            .dispatch("Utility/setMerchant", res.data.event.merchant.s)
            .then(() => {
              this.$store
                .dispatch("Utility/setEvent", res.data.event.slug)
                .then(() => {
                  // console.log(header);
                  this.$store.dispatch("Utility/setHeader", header);
                  let queries = {
                    s: res.data.event.merchant.folder,
                    e: this.$route.query.e
                  };
                  this.$router.replace({ query: queries }).catch(() => { });
                });
            });
        })
        .catch(() => {
          /* this.$router.push("/pages/error-404").catch(() => {}); */
        });
    }
  },
  mounted() {
    this.getRole();
  },
  methods: {
    openHelp() {
      // $crisp.push(["do", "helpdesk:article:open", ["en", "16enm85"]]);
      // eslint-disable-next-line no-undef
      $crisp.push(["do", "helpdesk:search"])
    },
    getRole() {
      const folder = this.e
      Service.Event.get(folder)
          .then(res => {
              this.role = res.data.role
          })
          .catch(() => {})
    },
    setDefaultHeader() {
      //let s = this.permission[0].list[0].s;
      //let e = this.permission[0].list[0].biz.ev[0].e;

      Service.Event.get(this.e)
        .then(res => {
          let header = {
            slug: res.data.event.e,
            title: res.data.event.pro_name,
            excerpt: res.data.event.date,
            image: res.data.event.merchant.logo,
            action: "openEventList"
          };
          this.$store.dispatch("Utility/setHeader", header);
        })
        .catch();
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },

    onEventSubmit(
      // data
    ) { },
    doAction(
      // action
    ) {
      // this.$router.push("/events/" + this.header.e + "/view");
      this.eventDialog = true;
      return;
      // let data = {
      //   s: this.$route.query.s,
      //   e: this.$route.query.e
      // };

      // let params = Object.keys(data)
      //   .map(key => key + "=" + data[key])
      //   .join("&");

      // if (action == "openEventList") {
      //   this.$router.push("/profile/selectAssets");
      //   /*
      //   this.$store.dispatch("Event/setMyEvents", params).then(res => {
      //     if (res.success) {
      //       this.eventList = res.data.rows;
      //       this.eventsPopup = true;
      //     }
      //   });
      //   */
      // }
    }
  }
};
</script>
<style lang="scss" scoped>
.header-logo {
  max-width: 75px;
  max-height: 40px;
  position: absolute;
  margin: auto;
  transform: translate(0%, 0%);
}

.header-text {
  top: -3px;
  display: inline-block;
  max-width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 15px;
  line-height: 23x;
  position: absolute;
  left: 90px;
  padding: 0 40px 0 0;

  .icon {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
</style>
